<template>
<v-main  v-scroll="onScroll">
  <header-common :logo_background="backgroundUrl" :onTop="onTop" :page_title="page_title"></header-common>
  <v-container style="padding: 0px 0px;" v-if="false">
    <v-row align="center" justify="center" style="margin-top:75px; margin-bottom:30px;">
      <v-col md="5" style="margin-bottom:20px; text-align:left;">
        <span style="text-transform:uppercase; letter-spacing: 2px; font-weight: 900; color:gray;">Services</span><br/>
        <span style="color:#414a52; font-weight:700; font-size:38px;">Transports & Logistiques</span>
      </v-col>
      <v-col md="7" class="text-left"><p>Nous transportons vos marchandises dans n'importe quelle partie du monde, grâce à un service flexible intégré à vos exigences</p></v-col>
      <v-col cols="12" md="3" style="text-align:left;" class="single-service">
        <div style="height:60px;"><img src="https://demo.artureanec.com/html/transx/img/road_freight.svg" height="100%" /></div><br/>
        <div class="feature-title">Transport Terrestre</div>
        <p class="feature-content">Greenling sleeper; Owens pupfish large-eye bream kokanee sprat shrimpfish. Pacific hake false</p>
        <div class="hoverable"><v-btn rounded color="primary" class="borderable-btn" text to="services/road-freight" dark>{{ $vuetify.lang.t('$vuetify.continue_reading') }}</v-btn></div>
      </v-col>
      <v-col cols="12" md="3" style="text-align:left;" class="single-service" v-if="false">
        <div style="height:60px;"><img src="https://demo.artureanec.com/html/transx/img/shipping.svg" height="100%" /></div><br/>
        <div class="feature-title">Chartering</div>
        <p class="feature-content">Greenling sleeper; Owens pupfish large-eye bream kokanee sprat shrimpfish. Pacific hake false</p>
        <div class="hoverable"><v-btn rounded color="primary" class="borderable-btn" text to="services/sea-freight" dark>{{ $vuetify.lang.t('$vuetify.continue_reading') }}</v-btn></div>
      </v-col>
      <v-col cols="12" md="3" style="text-align:left;" class="single-service" v-if="false">
        <div style="height:60px;"><img src="https://i.imgur.com/vXLu0Kj.png" height="100%" /></div><br/>
        <div class="feature-title">Fret Aérien</div>
        <p class="feature-content">{{ "Services de fret aérien à destination et en provenance de toutes les grandes villes du monde. Avec nos services d’importation et d’exportation et notre réseau d’agents, nous sommes en mesure de fournir un service rapide et efficace qui réduira non seulement les frais de transport, mais également le temps de transport." | truncate(120,'...')}}</p>
        <div class="hoverable"><v-btn rounded color="primary" class="borderable-btn" text to="services/air-freight" dark>{{ $vuetify.lang.t('$vuetify.continue_reading') }}</v-btn></div>
      </v-col>
      <v-col cols="12" md="3" style="text-align:left;" class="single-service" v-if="false">
        <div style="height:60px;"><img src="https://i.imgur.com/iQM2gKl.png" height="100%" /></div><br/>
        <div class="feature-title">Service Maritime</div>
        <p class="feature-content">
          {{ "PRIME SHIPPING fournit dans le monde entier des services d'expédition de fret maritime vers et depuis tous les principaux ports du monde en déplaçant la cargaison à la fois en tant que chargement LCL -Moins que conteneur et FCL -Charge conteneur complet." | truncate(120,'...')}}
        </p>
        <div class="hoverable"><v-btn rounded color="primary" class="borderable-btn" text to="services/ship-freight" dark>{{ $vuetify.lang.t('$vuetify.continue_reading') }}</v-btn></div>
      </v-col>
    </v-row>
  </v-container>
  <v-container fluid>
    
    <v-container>
      <v-row>
          <v-col md="5" style="margin-bottom:20px; text-align:left;">
            <span style="text-transform:uppercase; letter-spacing: 2px; font-weight: 900; color:gray;" @click="editContent('page.services.title')">Services</span><br/>
            <span style="color:#414a52; font-weight:700; font-size:38px;" @click="editContent('page.services.subtitle')">Transports & Logistiques</span>
          </v-col>
          <v-col md="7" class="text-left"><p @click="editContent('page.services.description')">Nous transportons vos marchandises dans n'importe quelle partie du monde, grâce à un service flexible intégré à vos exigences</p></v-col>
      </v-row>
    </v-container>
     <v-container fluid>
         <v-row style="width:85%; margin: 0 auto;">
            <v-col cols="12" md="3" style="position:relative;">
              
              <router-link to="/services/ship-freight">
                <div class="image-service" style="position:relative;">
                    <div class="img-content" style="background: url('https://i.imgur.com/tzPdACy.jpg') center;"></div>
                    <div class="text-service">{{ $vuetify.lang.t('$vuetify.menu.ship_freight') }}</div>
                </div>
                <div class="description-service">{{ $vuetify.lang.t('$vuetify.menu.ship_freight') }} <v-spacer></v-spacer> <span class="service-position">01</span></div>
              </router-link>
            </v-col>
            <v-col cols="12" md="3" style="position:relative;">
              <router-link to="/services/sea-freight">
                <div class="image-service" style="position:relative;">
                    <div class="img-content" style="background: url('https://demo.artureanec.com/html/transx/img/box_4.jpg') center;"></div>
                    <div class="text-service">{{ $vuetify.lang.t('$vuetify.menu.sea_freight') }}</div>
                </div>
                <div class="description-service">{{ $vuetify.lang.t('$vuetify.menu.sea_freight') }} <v-spacer></v-spacer> <span class="service-position">02</span></div>
              </router-link>
            </v-col>
            <v-col cols="12" md="3" style="position:relative;">
              <router-link to="/services/air-freight">
                <div class="image-service" style="position:relative;">
                    <div class="img-content" style="background: url('https://demo.artureanec.com/html/transx/img/box_3.jpg') center;"></div>
                    <div class="text-service">{{ $vuetify.lang.t('$vuetify.menu.air_freight') }}</div>
                </div>
                <div class="description-service">{{ $vuetify.lang.t('$vuetify.menu.air_freight') }} <v-spacer></v-spacer> <span class="service-position">03</span></div>
              </router-link>
            </v-col>
            <v-col cols="12" md="3" style="position:relative;">
              <router-link to="/services/road-freight">
                <div class="image-service" style="position:relative;">
                    <div class="img-content" style="background: url('https://i.imgur.com/atYPuzt.jpg') center;"></div>
                    <div class="text-service">{{ $vuetify.lang.t('$vuetify.menu.road_freight') }}</div>
                </div>
                <div class="description-service">{{ $vuetify.lang.t('$vuetify.menu.road_freight') }} <v-spacer></v-spacer> <span class="service-position">04</span></div>
              </router-link>
            </v-col>
         </v-row>
     </v-container>
  </v-container>
  <v-container style="margin-top:100px;background:url('https://demo.artureanec.com/html/transx/img/footer-bg.png') right bottom no-repeat rgb(48, 55, 63)" fluid>
     <v-container>
         <v-row>
            <v-col cols="12" md="12" style="text-align:left;">
                <span style="text-transform:uppercase; letter-spacing: 2px; font-weight: 900; color:gray;" @click="editContent('page.services.how_we_works_subtitle')">STEPS FOR WORK</span><br/>
                <span style="color:white; font-weight:700; font-size:38px;" @click="editContent('page.services.how_we_works_title')">How we works</span>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12" md="3">
                <div class="step">
                    <span style="font-size:58px; color: #1976d4; font-weight:700;">01</span><br/>
                    <span class="step-title" @click="editContent('page.services.step_1_title')">Listening you</span>
                    <p @click="editContent('page.services.step_1_description')">Kokanee sprat shrimpfish. Pacific hake false trevally queen parrotfish Black prickleback</p>
                </div>
            </v-col>
            <v-col cols="12" md="3">
                <div class="step">
                    <span style="font-size:58px; color: #1976d4; font-weight:700;">02</span><br/>
                    <span class="step-title" @click="editContent('page.services.step_2_title')">Lane pairing analysis</span>
                    <p @click="editContent('page.services.step_2_description')">Kokanee sprat shrimpfish. Pacific hake false trevally queen parrotfish Black prickleback</p>
                </div>
            </v-col>
            <v-col cols="12" md="3">
                <div class="step">
                    <span style="font-size:58px; color: #1976d4; font-weight:700;">03</span><br/>
                    <span class="step-title" @click="editContent('page.services.step_3_title')">Check all details</span>
                    <p @click="editContent('page.services.step_3_description')">Kokanee sprat shrimpfish. Pacific hake false trevally queen parrotfish Black prickleback</p>
                </div>
            </v-col>
            <v-col cols="12" md="3">
                <div class="step">
                    <span style="font-size:58px; color: #1976d4; font-weight:700;">04</span><br/>
                    <span class="step-title" @click="editContent('page.services.step_4_title')">Fast & efficient delivery</span>
                    <p @click="editContent('page.services.step_4_description')">Kokanee sprat shrimpfish. Pacific hake false trevally queen parrotfish Black prickleback</p>
                </div>
            </v-col>
        </v-row>
     </v-container>
  </v-container>

  <v-container style="margin-top:100px;">
    <v-row>
        <v-col cols="12" md="4">
            <div class="text-left">
                <span style="text-transform:uppercase; letter-spacing: 2px; font-weight: 900; color:gray;">TESTIMONIALS</span><br/>
                <span style="color:#414a52; font-weight:700; font-size:38px;">What our clients <br />think about us</span>
            </div>
            <v-toolbar flat>
                <template v-slot:extension>
                    <v-tabs
                    v-model="tab"
                    centered
                    height="2px"
                    style="background: rgba(0,0,0,0.05); height:2px; width: fit-content; padding:0; margin:0; border-radius:20px;"
                    slider-color="#1976d4"
                    >
                    <v-tab
                        v-for="i in 3"
                        :key="i"
                        :href="`#tab-${i}`"
                    >
                    </v-tab>
                    </v-tabs>
                </template>
            </v-toolbar>
            
        </v-col>
        <v-col cols="12" md="8">
            <div class="quotes">
                <v-tabs-items style="background:transparent" v-model="tab">
                <v-tab-item
                    v-for="i in 3"
                    :key="i"
                    :value="'tab-' + i"
                >
                    <v-card style="background: transparent; text-align: left;" flat>
                    <v-card-text class="quote-content">{{ text }}</v-card-text>
                    <v-card-text class="quote-content">{{ text }}</v-card-text>
                    <v-card-text class="quote-content" style="color:black;"><span><b>Hamidoo,</b> <br> manager of Brandname</span></v-card-text>
                    </v-card>
                </v-tab-item>
                </v-tabs-items>
            </div>
        </v-col>
    </v-row>
  </v-container>
  <footer-prime></footer-prime>
</v-main>
</template>

<script>
import headerCommon from "../commons/header"
import footerPrime from "../commons/footer"
import logo_light from "../../../assets/logo_light.png"
import logo_dark from "../../../assets/logo_dark.png"
import aboutImg from "../../../assets/section_1.jpg"
import aboutCart from "../../../assets/about_cart.png"

export default {
  name: 'services',
  data: () => ({
      type: ['20" ', '40" '],
      inflammable: false,
      tabs: 'tab2',
      tab: null,
      onTop: true,
      gerbable: false,
    text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.',
      page_title: 'services',
      backgroundUrl: logo_light,
      aboutImage: aboutImg,
      aboutCart: aboutCart,
      team: [
        {name: 'Lorem Ipsum', profile_picture: 'https://demo.artureanec.com/html/transx/img/team_1.jpg'},
        {name: 'Lorem Ipsum', profile_picture: 'https://demo.artureanec.com/html/transx/img/team_2.jpg'},
        {name: 'Lorem Ipsum', profile_picture: 'https://demo.artureanec.com/html/transx/img/team_3.jpg'},
        {name: 'Lorem Ipsum', profile_picture: 'https://demo.artureanec.com/html/transx/img/team_4.jpg'},
        {name: 'Lorem Ipsum', profile_picture: 'https://demo.artureanec.com/html/transx/img/team_5.jpg'},
        {name: 'Lorem Ipsum', profile_picture: 'https://demo.artureanec.com/html/transx/img/team_6.jpg'}
      ]
    }),
    methods: {
      onScroll() {
        if(document.documentElement.scrollTop === 0 ){
          this.backgroundUrl = logo_light
          this.onTop = true
        }else{
          this.backgroundUrl = logo_dark
          this.onTop = false
        }
      },
      editContent(name){
        //console.log(name+' - index')
        this.$emit("edit", {name: name, page: 'Services'})
      },
    },
    components: {
      headerCommon, footerPrime
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;700&display=swap');
.borderable-btn {
  border:2px solid #1976d2a1;
}
.single-service{
  position:relative;
}
.single-service .hoverable {
  position:absolute;
  width:100%;
  opacity: 0;
  transition: opacity .4s linear .2s;
}
.single-service:hover .hoverable{
  opacity: 1;
}
.quotes {
    background: url('https://i.imgur.com/yOZlJRU.png') no-repeat top left;
    background-size: 80px;
}
.quote-content {
    font-size: 16px;
    line-height: 25px;
    padding: 35px;
}
.list-about .v-icon {
  padding-right:20px;
  color:#1976d2;
}
.step {
    text-align:left;
    color: white;
}
.feature-content{
  font-size: 14px;
  letter-spacing: 1px;
  padding-top: 10px;
  line-height: 26px;
}

.feature-title{
  padding-top: 0px;
  font-size: 18px;
  font-weight: 700;
}
.step-title {
    font-weight:700;
    font-size:18px;
    margin-bottom:15px;
    display: block;
}
.img-content {
    width:100%;
    height:550px;
    background-size:cover !important;
}
*{
  transition: all .3s ease-in;
}
.image-service{
    overflow: hidden;
}
.image-service:hover .img-content {
    transform: scale(1.2);
}
.service-position {
    font-size:36px;
    color: #41abff;
}
.description-service {
    position: absolute;
    bottom: 22px;
    left: 0;
    right: 0;
    width: 95%;
    padding: 0 30px 13px 30px;
    margin: 0 auto;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: baseline;
    -ms-flex-align: baseline;
    align-items: baseline;
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    justify-content: space-between;
    z-index: 1;
    font-size:20px;
    font-weight:700;
    color: white;
}
.text-service {
    position: absolute;
    top: 230px;
    left: 25px;
    color: #f3f6f5;
    font-size: 12px;
    font-weight: 700;
    text-transform: uppercase;
    -webkit-transform: rotate(-90deg);
    -ms-transform: rotate(-90deg);
    transform: rotate(-90deg);
    -webkit-transform-origin: 0 0;
    -ms-transform-origin: 0 0;
    transform-origin: 0 0;
    z-index: 1;
}

* {
  font-family: 'Inter', sans-serif;
}
.back-head{
  color: transparent;
  font-family: Arial, Helvetica, sans-serif !important;
  -webkit-text-fill-color: transparent; /* Will override color (regardless of order) */
  -webkit-text-stroke-width: 1px;
  -webkit-text-stroke-color: rgba(255,255,255,0.2);
  position: absolute;
  left:0;
  right:0;
  text-transform: uppercase;
  font-size:74px;
  font-weight:900;
}
.font-back-content{
  color: transparent;
  font-family: Arial, Helvetica, sans-serif !important;
  -webkit-text-fill-color: transparent; /* Will override color (regardless of order) */
  -webkit-text-stroke-width: 1px;
  -webkit-text-stroke-color: rgba(0,0,0,0.2);
  position: absolute;
  left:0;
  right:0;
  text-transform: uppercase;
  font-size:74px;
  font-weight:900;
}
#header-website .v-btn{
  border-radius: 20px;
}
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
.headline {
  font-size: 64px;
  text-shadow: 0 0 20px rgba(0,0,0,0.6);
  font-weight: 700;
}
.text-caption{
  width:50%;
  text-align: center;
  margin: 0 auto;
  margin-top: 50px;
}
</style>



// WEBPACK FOOTER //
// src/views/website/services/listing.vue